export const organizationConstants = {
    FETCH_BRANDING_REQUEST: 'FETCH_BRANDING_REQUEST',
    FETCH_BRANDING_SUCCESS: 'FETCH_BRANDING_SUCCESS',
    FETCH_BRANDING_FAILURE: 'FETCH_BRANDING_FAILURE',

    UPDATE_BRANDING_REQUEST: 'UPDATE_BRANDING_REQUEST',
    UPDATE_BRANDING_SUCCESS: 'UPDATE_BRANDING_SUCCESS',
    UPDATE_BRANDING_FAILURE: 'UPDATE_BRANDING_FAILURE',
};
